/**
 * Admin Feature Constants
 * All hard-coded values, configuration options, and enums for the admin feature
 */

// ============================================================================
// ADMIN PERMISSIONS
// ============================================================================

/**
 * Admin permission levels
 */
export const ADMIN_PERMISSIONS = {
  // User Management
  MANAGE_USERS: "manage_users",
  CREATE_USER: "create_user",
  UPDATE_USER: "update_user",
  DELETE_USER: "delete_user",
  VIEW_USER: "view_user",
  ASSIGN_ROLES: "assign_roles",
  
  // Package Management
  MANAGE_PACKAGES: "manage_packages",
  VIEW_ALL_PACKAGES: "view_all_packages",
  UPDATE_PACKAGE_STATUS: "update_package_status",
  DELETE_PACKAGE: "delete_package",
  
  // Invoice Management
  MANAGE_INVOICES: "manage_invoices",
  GENERATE_INVOICE: "generate_invoice",
  MARK_INVOICE_PAID: "mark_invoice_paid",
  
  // System Settings
  MANAGE_SETTINGS: "manage_settings",
  VIEW_LOGS: "view_logs",
  MANAGE_CITIES: "manage_cities",
  MANAGE_PRICING: "manage_pricing",
  
  // Reports
  VIEW_REPORTS: "view_reports",
  EXPORT_DATA: "export_data",
};

// ============================================================================
// SYSTEM SETTINGS CATEGORIES
// ============================================================================

/**
 * System settings categories
 * Use translation keys for labels: t(`admin.settings.${value}`)
 */
export const SYSTEM_SETTINGS_CATEGORIES = [
  { value: "general", label: "admin.settings.general" },
  { value: "email", label: "admin.settings.email" },
  { value: "sms", label: "admin.settings.sms" },
  { value: "payment", label: "admin.settings.payment" },
  { value: "shipping", label: "admin.settings.shipping" },
  { value: "security", label: "admin.settings.security" },
  { value: "api", label: "admin.settings.api" },
];

// ============================================================================
// LOG TYPES
// ============================================================================

/**
 * System log types
 * Use translation keys for labels: t(`admin.logs.${value}`)
 */
export const LOG_TYPES = [
  { value: "info", label: "admin.logs.info" },
  { value: "warning", label: "admin.logs.warning" },
  { value: "error", label: "admin.logs.error" },
  { value: "debug", label: "admin.logs.debug" },
  { value: "security", label: "admin.logs.security" },
  { value: "audit", label: "admin.logs.audit" },
];

// ============================================================================
// REPORT TYPES
// ============================================================================

/**
 * Available report types
 * Use translation keys for labels: t(`admin.reports.${value}`)
 */
export const REPORT_TYPES = [
  { value: "packages", label: "admin.reports.packages" },
  { value: "invoices", label: "admin.reports.invoices" },
  { value: "revenue", label: "admin.reports.revenue" },
  { value: "users", label: "admin.reports.users" },
  { value: "deliveries", label: "admin.reports.deliveries" },
  { value: "performance", label: "admin.reports.performance" },
];

// ============================================================================
// ROUTE PATHS
// ============================================================================

/**
 * Admin-related route paths
 */
export const ADMIN_ROUTES = {
  DASHBOARD: "/admin/dashboard",
  USERS: "/admin/users",
  SYSTEM_SETTINGS: "/admin/settings",
  LOGS: "/admin/logs",
  REPORTS: "/admin/reports",
  CITIES: "/admin/cities",
  PRICING: "/admin/pricing",
  AUDIT_TRAIL: "/admin/audit",
};

// ============================================================================
// TOAST MESSAGE KEYS
// ============================================================================

/**
 * Toast message translation keys for admin operations
 */
export const ADMIN_TOAST_KEYS = {
  SETTINGS_UPDATED: "admin.settingsUpdated",
  USER_ROLE_CHANGED: "admin.userRoleChanged",
  SYSTEM_ACTION_SUCCESS: "admin.systemActionSuccess",
  SYSTEM_ACTION_FAILED: "admin.systemActionFailed",
  PERMISSION_DENIED: "admin.permissionDenied",
};

// ============================================================================
// QUERY KEYS
// ============================================================================

/**
 * React Query keys for admin-related queries
 */
export const ADMIN_QUERY_KEYS = {
  DASHBOARD: "admin-dashboard",
  SYSTEM_SETTINGS: "system-settings",
  LOGS: "system-logs",
  REPORTS: "admin-reports",
  AUDIT_TRAIL: "audit-trail",
  SYSTEM_STATS: "system-stats",
};

// ============================================================================
// SYSTEM USER ACCOUNTS
// ============================================================================

/**
 * System user identifiers (e.g., for automated operations)
 */
export const SYSTEM_USERS = {
  SPEEDAF: "speedaf",
  SYSTEM: "system",
};
